import React, { useState} from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, Tooltip } from 'recharts';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';

interface YearCardProps {
    library: any[]; // Define the type of elements in the library array if known
}
  

const YearCard: React.FC<YearCardProps> = ({ library }) => {

    const [chosenYear, setChosenYear] = useState(new Date().getFullYear());

    const navigate = useNavigate();

    const data = [
        {
          name: 'January',
          label: 'J',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 0 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'February',
          label: 'F',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 1 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'March',
          label: 'M',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 2 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'April',
          label: 'A',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 3 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'May',
          label: 'M',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 4 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'June',
          label: 'J',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 5 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'July',
          label: 'J',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 6 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'August',
          label: 'A',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 7 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'September',
          label: 'S',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 8 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },  
        {
          name: 'October',
          label: 'O',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 9 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'November',
          label: 'N',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 10 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        },
        {
          name: 'December',
          label: 'D',
          books: library.filter((book) => new Date(book['Date Read']).getMonth() === 11 && new Date(book['Date Read']).getFullYear() === chosenYear).length,
        }

    ];

    const yearsWithBooks = Array.from(
      new Set(
        library
          .filter((book) => !!book['Date Read'])
          .map((book) => new Date(book['Date Read']).getFullYear())
          .filter((year) => !isNaN(year))
      )
    ).sort((a, b) => b - a);

    const CustomTooltip = ({ active, payload, label } : any) => {
        if (active && payload && payload.length) {
          return (
            <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
              <p className="label" style={{ fontWeight: 'bold' }}>{`${payload[0].payload.name}`}</p>
              <p>{`${payload[0].name} : ${payload[0].value}`}</p>
            </div>
          );
        }
      
        return null;
      };

    if (library.length <= 0) {
        // loader
        return (
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
                <div className="loader"></div> 
            </div>
        )
    }

    return (
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full">
            <div className='flex justify-between items-center'>
              <div className='mb-4'>
                <h1 className="text-2xl font-bold  text-[#60637A]">
                    Year stats 
                </h1>
                <p className="text-gray-600 m-0 p-0">
                {library?.filter((book) => new Date(book['Date Read']).getFullYear() === chosenYear).length} books read in {chosenYear}
                </p>
              </div>

                <Menu as="div" className="relative inline-block text-left">
                    <div>
                        <MenuButton className="inline-flex items-center w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        {chosenYear}
                        {/* <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="10px" width="10px" version="1.1" id="Layer_1" viewBox="0 0 407.437 407.437">
                            <polygon points="386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 "/>
                        </svg>
                        </MenuButton>
                    </div>

                    <MenuItems
                        transition
                        className="absolute right-0 z-10 mt-2 w-100 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        {/* {[2022, 2023, 2024, 2025].map((item) => (
                            item !== chosenYear && <div className="py-1">
                             <MenuItem>
                                 <button
                                    onClick={() => setChosenYear(item)}
                                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                 >
                                 {item}
                                 </button>
                             </MenuItem>
                         </div>
                        ))} */}

                        {yearsWithBooks?.filter((year) => year !== chosenYear)
                          .map((year) => (
                            <div key={year} className="py-1">
                              <MenuItem>
                                <button
                                  onClick={() => setChosenYear(year)}
                                  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                >
                                  {year}
                                </button>
                              </MenuItem>
                            </div>
                        ))}
                       
                </MenuItems>
                </Menu>
            </div>

            <div style={{ width: '100%', height: '180px', cursor: 'pointer' }} onClick={() => navigate(`/timeline/${chosenYear}`)}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart width={150} height={40} data={data}>
                        <XAxis dataKey="label" />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="books" fill="#8884d8" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default YearCard;
